import { render, staticRenderFns } from "./barrage-slide.vue?vue&type=template&id=b77b4360&scoped=true"
import script from "./barrage-slide.vue?vue&type=script&lang=ts"
export * from "./barrage-slide.vue?vue&type=script&lang=ts"
import style0 from "./barrage-slide.vue?vue&type=style&index=0&id=b77b4360&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77b4360",
  null
  
)

export default component.exports